import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    props: {},
    computed: {
        ...mapState('categoriesModule', [
            'menuCategories'
        ]),
    },
    beforeDestroy() {
        this.$el.querySelectorAll('.modal.show').forEach(modal => {
            modal.classList.remove('fade');
            const closeButton = modal.querySelector('[data-dismiss="modal"]');
            closeButton?.click();
        });
    },
});
